import React, { useEffect, useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ChecklistIcon from "@mui/icons-material/Checklist";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

import server from "../../variables";
import { Dashboardcard } from "../../components/dashboardcard";
import AddSchemeModal from "../../components/Schemeregistermodal";

const SADashboard = () => {
  const notyf = new Notyf();
  const navigate = useNavigate();

  const [schemes, setSchemes] = useState([]);
  const [search, setSearch] = useState("");
  const [showSchemeModal, setShowSchemeModal] = useState(false);

  useEffect(() => {
    document.title = "Super Admin Dashboard | RBS";
    fetchSchemes();
  }, []);

  const fetchSchemes = async () => {
    try {
      const { data } = await Axios.get(`${server}admin/get-schemes`, {
        headers: { authorization: localStorage.getItem("token") },
      });

      if (data.status === 410) return navigate("/");
      if (data.status !== 200) throw new Error(data.message);

      setSchemes(data.data);
    } catch (err) {
      notyf.error("Failed to load schemes");
    }
  };

  const filteredSchemes = useMemo(() => {
    return schemes.filter((s) =>
      search
        ? `${s.name}${s.city}${s.schemeID}`
            .toLowerCase()
            .includes(search.toLowerCase())
        : true
    );
  }, [schemes, search]);

  const columns = useMemo(
    () => [
      { name: "Scheme ID", selector: (r) => r.schemeID, sortable: true },
      { name: "Scheme Name", selector: (r) => r.name, sortable: true, wrap: true },
      { name: "Project Name", selector: (r) => r.projectname, sortable: true },
     {
  name: "Created At",
  selector: (r) => {
    if (!r.createdAt) return "-"
    const date = new Date(r.createdAt)
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
  },
  sortable: true,
},
      {
        name: "Actions",
        center: true,
        cell: (row) => (
          // <EditIcon
          //   style={{ cursor: "pointer", color: "#f0ad4e" }}
          //   onClick={() => navigate(`/admin/scheme/${row.schemeID}`)}
          // />
  <button
            className="btn btn-outline-primary btn-sm"
           onClick={() => navigate(`/admin/scheme/${row.schemeID}`)}
          >
            <i className="bi bi-eye-fill"></i>
          </button>


        ),
      },
    ],
    [navigate]
  );

  return (
    <div className="page-wrapper bg-light min-vh-100">
   
      <div className="container mt-4">
           <div className="row g-4 mb-3">
  {[
    { label: "Total Schemes", count:0 },
    { label: "Total User", count: 0 },
        { label: "Total Consumer", count:0 },
    { label: " Total Generated Bill", count: 0 },

  ].map((card, index) => (
    <div key={index} className="col-12 col-sm-6 col-lg-3">
      <div
        className="card shadow-sm rounded-4 border-0"
        style={{ minHeight: "110px" }}
      >
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted small">{card.label}</div>
            <div className="fw-bold fs-4">{'-'}</div>
          </div>
          <ChecklistIcon className="text-primary" fontSize="large" />
        </div>
      </div>
    </div>
  ))}
</div>

        <Card className="shadow-sm rounded-4 border-0 p-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
                <div className="input-group shadow-sm search-input">
              <span className="input-group-text bg-white border-0">
                <i className="bi bi-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-0"
                placeholder="Search by name, email or ID"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() => setShowSchemeModal(true)}
            >
              <AddIcon /> 
            </button>
          </div>

          <DataTable
            columns={columns}
            data={filteredSchemes}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10]}
            highlightOnHover
            striped
            responsive
            noDataComponent="No schemes found"
            className="rounded-3"
          />
        </Card>
      </div>

      <AddSchemeModal
        show={showSchemeModal}
        handleClose={() => setShowSchemeModal(false)}
        fetch={fetchSchemes}
      />
    </div>
  );
};

export default SADashboard;